import { ACTOR_ID_HEADER_KEY, PAYMENT_SERVICE_BASE_URL } from "constants";
import apiClient from "utils/apiClient";

const BASE = `${PAYMENT_SERVICE_BASE_URL}/api/v1/user-payrolls`;

const actorHeaders = (actorId) =>
  actorId ? { [ACTOR_ID_HEADER_KEY]: actorId } : {};

export const userPayrollService = {
  getForUser: async ({ actorId, userId } = {}) => {
    const response = await apiClient.get(`${BASE}/users/${encodeURIComponent(userId || actorId)}`, {
      headers: actorHeaders(actorId),
    });
    return response.data || null;
  },

  linkWorkspace: async ({ actorId, userId, workspaceId } = {}) => {
    const response = await apiClient.put(
      `${BASE}/users/${encodeURIComponent(userId || actorId)}/workspace`,
      { workspaceId },
      { headers: actorHeaders(actorId) },
    );
    return response.data || null;
  },

  listPayRates: async ({ actorId, userId, workspaceId } = {}) => {
    const response = await apiClient.get(`${BASE}/users/${encodeURIComponent(userId || actorId)}/pay-rates`, {
      headers: actorHeaders(actorId),
      params: {
        workspaceId,
        wid: workspaceId,
      },
    });
    return response.data || [];
  },

  getCurrentPayRate: async ({ actorId, userId, workspaceId } = {}) => {
    const response = await apiClient.get(`${BASE}/users/${encodeURIComponent(userId || actorId)}/pay-rates/current`, {
      headers: actorHeaders(actorId),
      params: {
        workspaceId,
        wid: workspaceId,
      },
    });
    return response.data || null;
  },

  createPayRate: async ({ actorId, userId, workspaceId, payRate } = {}) => {
    const response = await apiClient.post(
      `${BASE}/users/${encodeURIComponent(userId || actorId)}/pay-rates`,
      payRate,
      {
        headers: actorHeaders(actorId),
        params: {
          workspaceId,
          wid: workspaceId,
        },
      },
    );
    return response.data || null;
  },
};

export default userPayrollService;
